import { ref } from 'vue'
import { functions, httpsCallable } from '@/firebase/config'

const error = ref(null)

const deleteUserCredential = async (userCredential) => {
  error.value = null
  const deleteUser = httpsCallable(functions, 'deleteUser')

  deleteUser({ userCredential }).then(result => {
    console.log(result)
  }).catch((error) => {
    // Getting the Error details.
    const code = error.code
    const message = error.message
    const details = error.details
    error.value = code + message + details
    // ...
  })
}
// Call updateUser.js
const useDeleteUser = () => {
  return { error, deleteUserCredential }
}

export default useDeleteUser
